// src/modules/Rules/services/Service.ts
import { RulesApiAdapter } from '../adapters/RulesApiAdapter';
import { Filters } from '../models/Filters';
import { RulesModel } from '../models/Rules';

export interface Page {
  rules: RulesModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: RulesApiAdapter) {}

  /**
   * Obtiene todas las reglas sin paginación.
   */
  async getAll(filters: Filters = {}): Promise<RulesModel[]> {
    return this.apiAdapter.getAll();
  }

  /**
   * Obtiene reglas paginadas con validaciones de filtros.
   */
  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    return this.apiAdapter.getRulesPaginated(filters);
  }

  /**
   * Activa o desactiva una regla.
   * @param ruleId ID de la regla
   * @param activate true para activar, false para desactivar
   */
  async toggleRule(ruleId: number, activate: boolean): Promise<void> {
    await this.apiAdapter.toggle(ruleId, activate);
  }

  /**
   * Elimina una regla por su ID.
   * @param ruleId ID de la regla a eliminar
   */
  async deleteRule(ruleId: number): Promise<void> {
    await this.apiAdapter.deleteRule(ruleId);
  }
}
